/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import { useAdminParams } from 'utils/helpers';
import { Notification } from 'utils/types';

const EventDescription = {
  EVENT_INVITE: (_n?: Notification) => 'You are invited to an event.',
  EVENT_UPDATED: (_n?: Notification) =>
    'An event you are invited has been updated.',
  EVENT_CANCELLED: (_n?: Notification) =>
    'An event you are invited has been Cancelled.',
  EVENT_REMINDER: (_n?: Notification) => 'An event is about to start.',
};

const EventLogs = {
  EVENT_INVITE: {
    title: 'Calendar Invite',
    description: (_n?: Notification) => EventDescription.EVENT_INVITE(_n),
    element: ({ actor, meta, referenceId }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account')
          return `/calendar/calendar?selectedEvent=${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/calendar/calendar?selectedEvent=${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const event = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {EventDescription['EVENT_INVITE']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Event Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={event}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
  EVENT_UPDATED: {
    title: 'Calendar Invite Update',
    description: (_n?: Notification) => EventDescription.EVENT_UPDATED(_n),
    element: ({ actor, meta, referenceId }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account')
          return `/calendar/calendar?selectedEvent=${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/calendar/calendar?selectedEvent=${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const event = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {EventDescription['EVENT_UPDATED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Event Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={event}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
  EVENT_CANCELLED: {
    title: 'Event Cancelled',
    description: (_n?: Notification) => EventDescription.EVENT_CANCELLED(_n),
    element: ({ meta }: Notification) => {
      const event = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {EventDescription['EVENT_CANCELLED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Event Name:</span>
            <p className="text-title text-xs font-semibold">{event}</p>
          </div>
        </>
      );
    },
  },
  EVENT_REMINDER: {
    title: 'Pre-Event Notice',
    description: (_n?: Notification) => EventDescription.EVENT_REMINDER(_n),
    element: ({ meta, referenceId }: Notification) => {
      const navigate = useNavigate();
      const {
        state: { isPreview },
      } = useAppWrapperContext();

      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (!isPreview)
          return `/calendar/calendar?selectedEvent=${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/calendar/calendar?selectedEvent=${referenceId}`;
      }, [isPreview, accountId, accountUserId, referenceId]);

      const event = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {EventDescription['EVENT_REMINDER']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Event Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={event}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
};

export default EventLogs;
